import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function passwordMatchingValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const password = control.get('password');
    const confirmPassword = control.get('confirm_password');

    // If either field is empty, don't show the mismatch error
    // (required validator will handle empty fields)
    if (!password || !confirmPassword) {
      return null;
    }

    // Check if passwords match
    if (password.value !== confirmPassword.value) {
      return { notmatched: true };
    }

    return null;
  };
}
